<template>
  <div class='nav' id='snav'>
    <Menu :theme="theme3" :active-name="curIndex" ref="curIndex" :open-names="curName" @on-select='changeNavItem'
      :accordion='true'>
      <MenuGroup>
        <template v-for='(item, index) in routers'>
          <Submenu :name="index" v-if='item.children.length > 0' :key='index' :data-id='index'>
            <template slot="title">
              <Icon :type="item.icon" size='18' class='beicon' />
              {{ item.name }}

            </template>
            <MenuItem v-for='(items, indexs) in item.children' v-if='item.children.length > 0'
              :data-id="getIndex(index, indexs)" :key='indexs' :name="getIndex(index, indexs)">

            <span v-if='items.ahref'>{{ items.name }}</span>
            <span v-else>{{ items.name }}</span>

            <!-- <span class='dot' v-if='curIndex==getIndex(index,indexs)'></span> -->
            </MenuItem>

          </Submenu>

          <MenuItem :name="index" :data-id='index' :to='item.url'
            :class='[curIndex == index ? "ivu-menu-item-active ivu-menu-item-selected" : ""]' v-else>

          <Icon :type="item.icon" size='18' class='beicon' />

          <span v-if='item.ahref'>{{ item.name }}</span>
          <span v-else>{{ item.name }}</span>
          <!-- <span class='dot' v-if='curIndex==index'></span> -->
          </MenuItem>
        </template>
      </MenuGroup>
    </Menu>
    <div class='lineLine'></div>
  </div>
</template>

<script>
export default {
  name: 'sgnav',
  data () {
    return {
      userInfo: {},
      curName: [],
      schoolItem: '',
      schoolList: [],
      visible: false,
      theme1: 'light',
      theme3: 'light',
      curIndex: 0,
      curTab: 0,
      routers: [],
      initrouters: []
    }
  },
  mounted () {

    var that = this
    this.curIndex = localStorage.getItem('inchleftcurIndex') || '0'
    this.curTab = localStorage.getItem('inchcurTab') || '0'
    this.userInfo = JSON.parse(localStorage.getItem('inchUserinfo'))
    this.routers = JSON.parse(localStorage.getItem('inchheadermenu'))[this.curTab]['children']
    localStorage.setItem('inchleftnav', JSON.stringify(this.routers))



  },
  watch: {
    '$route': function (to, from) {
      var that = this
      this.curTab = localStorage.getItem('inchcurTab')
      this.routers = JSON.parse(localStorage.getItem('inchheadermenu'))[this.curTab]['children']
      localStorage.setItem('inchleftnav', JSON.stringify(this.routers))
      this.curIndex = localStorage.getItem('inchleftcurIndex')
      this.checkToken()
    }
  },
  methods: {

    changeSchool (e) {

      localStorage.setItem('curSchoolid', e)
      this.$emit('changeSchoolInfo', e)
    },
    show: function () {
      this.visible = true;
    },
    checkToken () {
      var that = this
      var _tokenexprie = localStorage.getItem('expiresTo') || ''
      var username = localStorage.getItem('jwjcurUsername')
      var password = localStorage.getItem('jwjcurUserpwd')

      // console.log('checktoken', _tokenexprie)


      if (_tokenexprie != '') {

        if (this.CompareDate(_tokenexprie) < 3) {

          that.axios.post('oauth/token', {
            username: username,
            password: password,
            sms_code: '',
            grant_type: 'password',
            systemid: 'web'
          }).then(back => {

            if (back && back.data && back.data['access_token']) {
              localStorage.setItem('access_token', back.data['access_token'])
              localStorage.setItem('expiresTo', back.data['expires_to'])
            }
          })
        }


      }
    },
    CompareDate (d1) {
      var myDate = new Date();
      var myYear = myDate.getFullYear();
      var myMonth = myDate.getMonth();
      var myDay = myDate.getDate();
      var d2 = myYear + "-"
        + (myMonth < 9 ? ("0" + (myMonth + 1)) : (myMonth + 1)) + "-"
        + (myDay < 10 ? ("0" + myDay) : myDay);
      d2 += ' 00:00:00'

      return this.getDiffDay(d1, d2)
      return ((new Date(d1.replace(/-/g, "\/"))) > (new Date(d2.replace(/-/g, "\/"))));
    },
    getDiffDay (date_1, date_2) {
      let totalDays, diffDate
      let myDate_1 = Date.parse(date_1)
      let myDate_2 = Date.parse(date_2)
      diffDate = Math.abs(myDate_1 - myDate_2)
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
      return totalDays
    },
    scrollTo: function (href) {

      if (href.indexOf('/appcenter/') > -1) {
        href = href.replace('/appcenter/', '')
      }
      window.location.hash = "#" + href

      var x = document.querySelectorAll("h3")
      for (var i = 0; i < x.length; i++) {
        x[i].style.color = '#515a6e'
      }
      if (document.getElementById(href)) {
        document.getElementById(href).style.color = '#e22a1c'
      } else {
        // this.$router.push('/appcenter/'+href)
        this.$router.push('/appcenter#' + href)
      }

    },
    scrollToAnima (y, duration) {
      /*y:目标纵坐标,duration:时间(毫秒)*/
      var scrollTop = document.body.scrollTop; /*页面当前滚动距离*/
      var distance = y - scrollTop; /*结果大于0,说明目标在下方,小于0,说明目标在上方*/
      var scrollCount = duration / 10; /*10毫秒滚动一次,计算滚动次数*/
      var everyDistance = distance / scrollCount /*滚动距离除以滚动次数计算每次滚动距离*/
      for (var index = 1; index <= scrollCount; index++) /*循环设置scrollBy事件,在duration之内,完成滚动效果*/
        setTimeout(function () {
          window.scrollBy(0, everyDistance)
        }, 10 * index);
    },
    getIndex (a, b) {

      return a + '-' + b
    },
    changeNavItem: function (e, b, c) {

      this.curIndex = e
      localStorage.setItem('inchleftcurIndex', e)
      var that = this
      var _curHref = window.location.href

      // ////console.log(that.curIndex, e, _curHref, _curHref.indexOf('/appcenter') > -1, '----------->')
      // ////console.log(this.userInfo)

      if (String(e).indexOf('-') > -1) {
        var leftNav = e.split('-')
        ////console.log(this.routers, leftNav)
        var _href = this.routers[leftNav[0]]['children'][leftNav[1]]['url']
        that.$router.push(_href)
      }


      // }




    }
  }
}
</script>

<style scoped>
>>>.ivu-menu-vertical .ivu-menu-item {}

>>>.ivu-menu-vertical .ivu-menu-item,
>>>.ivu-menu-vertical .ivu-menu-submenu-title {}

.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item {}

>>>.ivu-menu-vertical a {
  width: 160px;

  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 5px;
  margin-bottom: 10px;
  color: #515a6e;
  cursor: pointer;

}

>>>.ivu-menu-vertical a.ivu-menu-item-active {
  font-weight: bold;

  background: rgba(226, 42, 28, .05);
  color: #e22a1c;
  font-weight: 700;
}

>>>.ivu-menu-submenu-title {
  /* background: rgba(226,42,28,.05); */
  /* color: #e22a1c;
    font-weight: 700; */
  /* width:160px; */
}

>>>.ivu-menu-vertical a.ivu-menu-item-active i {
  color: #e22a1c
}

>>>.ivu-menu-vertical .ivu-menu-item-group-title {
  height: 0px;
}

>>>.ivu-menu-vertical .ivu-menu-item-active.ivu-menu-submenu .ivu-menu-submenu-title {
  color: #e22a1c;
  /* 	color:#2db7f5 */
}

>>>.ivu-menu-vertical .ivu-menu-item-active.ivu-menu-submenu .ivu-menu-submenu-title i {
  color: #e22a1c;
  /* 	color:#2db7f5 */
}

#snav .avatar {
  width: 30px;
  height: 30px;
  margin-left: 20px;
  margin-top: 28px;
}

#snav .svgpic {
  margin-left: 40px;
  margin-top: 33px;
}

>>>.ivu-menu-vertical .ivu-menu-item,
>>>.ivu-menu-vertical .ivu-menu-submenu-title {
  /* padding-left: 35px; */
}

>>>.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item {
  padding-left: 62px !important;
}

>>>.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active {
  font-weight: bold;
  color: #e22a1c
    /* 	color:#2db7f5 */
}

#snav .crossLine {
  height: 3px;
  background: #f1f3f4;
  margin-left: 35px;
  margin-right: 35px;
  margin-top: 10px;
}

#snav .lineLine {
  width: 2px;
  background: #f1f3f4;
  height: 300px;
  position: absolute;
  right: 60px;
  top: 120px;
  z-index: 1000;
}

.nav {
  position: fixed !important;
  background: #fff;
  padding: 40px 14px;
  box-sizing: border-box;
  height: 100%;
  overflow: scroll !important;
  z-index: 9;
  padding-bottom: 100px;
}

::-webkit-scrollbar {

  height: 0;

  width: 0;

  color: transparent;

}

>>>.ivu-menu-item-group ul {
  /* overflow-x:visible;
  overflow-y: scroll;
  margin-bottom:50px;
  height:200px; */
}

.nav img.icon {
  width: 20px;
  height: 20px;
  position: relative;
  top: 5px;
  margin-right: 14px;
}

.nav .beicon {
  position: relative;
  top: 0px;
  margin-right: 15px;
  color: #21272e
}

#snav .dot {
  background: #4799f1;
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  position: absolute;
  right: 20%;
  top: 18px;
  box-shadow: 0px 2px 5px 0px rgba(71, 153, 241, .5)
}

>>>.ivu-select-selection {
  border: 0 none;

}

.schoolSelect {
  position: absolute;
  bottom: 20px;
  left: 5px;
}

>>>.ivu-select-visible .ivu-select-selection {
  box-shadow: 0 0 0 0
}

>>>.ivu-select-dropdown {
  min-width: 1200px !important;
  left: 30px !important;
  z-index: 1000;
}

>>>.ivu-select-dropdown-list .ivu-select-item {
  display: inline-block !important;
  float: left !important;
  clear: none !important;
  min-width: 180px;
}

>>>.ivu-menu-vertical .ivu-menu-submenu-title-icon {
  right: 60px;
}

#snav ul ul a:nth-of-type(6) {
  margin-bottom: 24px;

}

#snav ul ul a:nth-of-type(6)::after {
  content: '';
  display: block;
  width: 120px;
  height: 2px;
  background: #f1f3f4;
  position: relative;
  top: 12px;
  left: -10px;
}

>>>.ivu-menu-vertical .ivu-menu-item,
.ivu-menu-vertical .ivu-menu-submenu-title {
  transition: none
}

.ivu-menu-item span {
  display: inline-block;
  line-height: 40px;
}

>>>.ivu-menu-vertical .ivu-menu-item,
.ivu-menu-vertical .ivu-menu-submenu-title {
  padding: 0px 24px;
}
</style>
